<app-base-servico
  [servico]="servico"
  [activeIndex]="ACTIVE_INDEX"
  [headerTemplate]="headerTemplate"
  [solicitanteTemplate]="solicitanteTemplate"
  [confirmacaoTemplate]="confirmacaoTemplate"
  [servicoTemplate]="servicoTemplate"
>
</app-base-servico>

<ng-template #headerTemplate>
  <app-header-unidade
    [dadosUnidade]="dadosUnidade"
    (sair)="limparDadosUnidade()"
  ></app-header-unidade>
</ng-template>

<ng-template #solicitanteTemplate>
  <app-formulario-solicitante
    class="fadein animation-duration-500"
    [servico]="servico"
    [dadosUnidade]="dadosUnidade"
    [dadosSolicitante]="dadosSolicitante"
    (onUnidadeEncontrada)="putDadosUnidade($event)"
    (onEnviarSolicitante)="putDadosSolicitante($event)"
  ></app-formulario-solicitante>
</ng-template>

<ng-template #servicoTemplate>
  <app-formulario-servico
    class="fadein animation-duration-500"
    [servico]="servico"
    (onEnviarFormulario)="concluirCadastro($event)"
    [loading]="loading"
  ></app-formulario-servico>
</ng-template>

<ng-template #confirmacaoTemplate>
  <app-confirmacao-solicitacao
    class="fadein animation-duration-500"
    [dadosConfirmacao]="dadosSolicitacao"
  ></app-confirmacao-solicitacao>
</ng-template>
